import { render } from "./CustomerDetailInvoicesTab.vue?vue&type=template&id=d6c02640"
import script from "./CustomerDetailInvoicesTab.vue?vue&type=script&lang=js"
export * from "./CustomerDetailInvoicesTab.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__